<template>
  <div>
  <CustomTable ref="table" class="compact-table" :defaultItemsPerPages=5 :defaultIindex=0 :loadData="loadData">
    <template v-slot:table>
      <thead>
      <tr>
        <th class="col-fit">Date</th>
        <th class="col-fill">Mode</th>
        <th class="col-fit">Montant</th>
      </tr>
      </thead>
      <tbody v-if="data && data.length > 0 && data">
      <tr v-for="(collection, index) in data" :key="index" class="compact-row editable" title="Modifier l'encaissement" @click="openEditCollectionModal(collection)">
        <td class="col-fit">{{new Date(collection.date).toLocaleDateString("en-GB", formattedDate)}}</td>
        <td class="col-fill">{{convertPaymentType(collection.paymentType)}} · {{ purposeLabel(collection) }}</td>
        <td class="col-fit">{{ Number(collection.amount).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }} €
          <span v-if="collection.paymentPurpose === PAYMENT_PURPOSE.DEPOSIT.value" class="tooltip-container">
              <span class="fas fa-vault tooltip-icon deposit-icon"></span>
              <span class="tooltip-message">Acompte</span>
            </span>
        </td>
      </tr>
      </tbody>
      <tbody v-else><tr class="empty-row"><td colspan="3">Aucun encaissement enregistré</td></tr></tbody>
    </template>
  </CustomTable>
  <EditCollectionModal ref="editCollectionModal" :callback="onCollectionEdited" />
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faVault } from "@fortawesome/free-solid-svg-icons";
import {CollectionController} from "@/controllers/business/CollectionController";
import CustomTable from "@/components/CustomTable.vue";
import EditCollectionModal from "@/components/modals/EditCollectionModal.vue";
import {PAYMENT_PURPOSE} from "@/models/paymentPurpose";
import {convertPaymentType, formattedDate} from "@/utils";
library.add(faVault);

export default {
  name: 'CollectionTable',
  // callback : appelé après la modification d'un encaissement (en plus du rechargement du tableau)
  props: ['callback'],
  computed: {
    formattedDate() {
      return formattedDate
    },
    PAYMENT_PURPOSE() {
      return PAYMENT_PURPOSE
    }
  },
  components: {
    CustomTable,
    EditCollectionModal
  },
  data() {
    return {
      data: [],
      businessId: undefined,
    };
  },
  methods: {
    convertPaymentType,
    purposeLabel(collection) {
      const purpose = Object.values(PAYMENT_PURPOSE).find(purpose => purpose.value === collection.paymentPurpose);
      if (!purpose) return "Non précisé";
      return collection.paymentPurpose === PAYMENT_PURPOSE.CREDIT_NOTE.value && collection.creditNoteNumber !== undefined
          ? `${purpose.label} AV${String(collection.creditNoteNumber).padStart(4, '0')}`
          : purpose.label;
    },
    async retrieveData(businessId){
      // We keep the id for pagination or filter
      this.businessId = businessId;
      this.$refs.table?.startLoading();
      this.data = [];
      const resp = await CollectionController.getAllByBusiness(businessId, this.$refs.table.$refs.paginationArray.urlParamsBuilder());
      if(!resp.errors){
        for(let i=0; i < resp.length ;i++){
          this.data.push(resp[i]);
        }
      }
      this.$refs.table?.stopLoading();
    },
    loadData(){
      this.retrieveData(this.businessId);
    },
    openEditCollectionModal(collection) {
      this.$refs.editCollectionModal.openModal({...collection, businessId: collection.businessId || this.businessId});
    },
    onCollectionEdited() {
      this.loadData();
      if (this.callback) this.callback();
    },
  }
}

</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';
@require '~/src/common/style/businessTable.styl';

td
  overflow visible

.editable
  cursor pointer

.deposit-icon
  color WARNING

.tooltip-container
  display inline-block
  position relative
  margin-left 8px
  vertical-align middle

  .tooltip-icon
    width 15px
    height 15px
    color WARNING
    &:hover + .tooltip-message
      visibility visible
      opacity 1

  .tooltip-message
    background-color white
    position absolute
    top 50%
    right calc(100% + 8px)
    transform translateY(-50%)
    white-space nowrap
    visibility hidden
    opacity 0
    z-index 10
    box-shadow 0 0 5px 0 rgba(0,0,0,.3)
    border-radius 5px
    padding 4px 8px
    transition visibility 0s, opacity .3s linear

  .tooltip-message:hover
    visibility visible
    opacity 1
</style>